<div class="re-container-headline re-mb-30 lg:re-mb-45">
  <h3>
    {{ 'confirmation.order.title' | translate }}
  </h3>
</div>

<div class="re-container-with-margin re-mb-60">
  <div class="re-text-sm re-leading-m re-mb-30 md:re-mb-45 lg:re-text-base lg:re-leading-2xl">
    {{ 'confirmation.order.description' | translate }}
  </div>
  <h2 class="re-mb-15 lg:re-mb-30">{{ 'confirmation.title' | translate }}</h2>
  <ul class="bdo-list__bullet_bigger re-text-sm re-leading-m lg:re-text-base lg:re-leading-2xl">
    <li
      [innerHTML]="'confirmation.order.acknowledgment' | translate: { emailAddress: email }">
    </li>
    @if (cancelDate) {
      <li class="re-mt-5"
        [innerHTML]="'confirmation.end.cancellationDate' | translate:
        { endDate: cancelDate | date }">
      </li>
    }
    @if (startDate) {
      <li class="re-mt-5"
        [innerHTML]="'confirmation.move.supplyBegins' | translate: { startDate: startDate | date }">
      </li>
    }
    @if (!availableDivisionInfos?.noAvailableDivisions) {
      <li class="re-mt-5" [innerHTML]="'confirmation.order.documents' | translate"></li>
    }
    @if (isRegistered || (loginService.isLoggedIn$ | async)) {
      <li class="re-mt-5" data-qa="online-account-stays">
        {{ 'confirmation.end.onlineAccount' | translate: { companyName: reBaseData.companyName } }}
      </li>
    }
    @if (divisionsForInfo) {
      <li class="re-mt-5" data-qa="cancelled-divisions">
        {{ 'confirmation.end.secureSupply' | translate: { division: divisionsForInfo } }}
      </li>
    }
    @if (tariffService.isEffzeh(productIds)) {
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.effzehVoucher' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.effzehPayout' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.effzehCompetition' | translate}}</li>
    }
    @if (tariffService.isHaieTariff(productIds)) {
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.haieVoucher' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.haiePayout' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.haieCompetition' | translate}}</li>
    }
  </ul>
</div>

@if (trustpilotUniqueUrl) {
  <bdo-trustpilot
    [trustpilotUniqueUrl]="trustpilotUniqueUrl">
  </bdo-trustpilot>
}

@if (!tariffService.isEffzeh(productIds) && !tariffService.isHaieTariff(productIds)) {
  <bdo-netcologne-teaser
    [postCode]="postCode"
    [trackingLocation]="TRACKING.LOCATION.MOVE_CONFIRMATION"
  ></bdo-netcologne-teaser>
}

<bdo-effzeh-strom-teaser [productIds]="productIds"></bdo-effzeh-strom-teaser>

<bdo-haie-strom-teaser [productIds]="productIds"></bdo-haie-strom-teaser>

<div class="re-container-with-margin re-mt-30">
  <bdo-text-link-icon
    [iconPosition]="'left'"
    [linkText]="'general.navigation.backToHomepage' | translate"
    [href]="reBaseData.hrefHomepage"
  ></bdo-text-link-icon>
</div>
